let nextId = 1;
export const uid = () => `b${Date.now()}_${nextId++}`;

export const SAMPLE_CONTACT = {
  name: "Priya Sharma",
  email: "priya@example.com",
  phone: "+91 98765 43210",
  product_name: "Premium Walker",
  city: "Mumbai",
  pin_code: "400001",
  date: "2025-04-15",
};

export const BLOCK_DEFAULTS = {
  heading: { type: "heading", text: "Hello {{name}},", size: 24, align: "left" },
  text: { type: "text", text: "Thank you for shopping with us. We have something special for you.", align: "left" },
  image: { type: "image", url: "", alt: "", link: "" },
  images: { type: "images", items: [{ url: "", link: "", alt: "" }, { url: "", link: "", alt: "" }] },
  button: { type: "button", text: "Shop Now", url: "https://example.com", color: "#A1090B", align: "center" },
  divider: { type: "divider" },
  spacer: { type: "spacer", height: 24 },
  html: { type: "html", html: '<p style="font-family:Arial,sans-serif;font-size:15px;color:#374151;">Hello {{name}}, this is <strong>custom HTML</strong>.</p>' },
  cards: {
    type: "cards",
    columns: 2,
    color: "#A1090B",
    items: [
      { image: "", title: "Product name", price: "₹4,999", old_price: "", url: "https://example.com", button: "Buy Now" },
      { image: "", title: "Product name", price: "₹6,999", old_price: "", url: "https://example.com", button: "Buy Now" },
    ],
  },
};

const escapeHtml = (s) =>
  String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/\n/g, "<br/>");

export function personalize(text, contact) {
  let out = text || "";
  Object.keys(SAMPLE_CONTACT).forEach((f) => {
    out = out.split(`{{${f}}}`).join(contact?.[f] || "");
  });
  return out;
}

export function renderBlocksHtml(blocks, contact) {
  return (blocks || [])
    .map((b) => {
      if (b.type === "heading")
        return `<h2 style="margin:0 0 8px;font-size:${b.size || 24}px;font-weight:700;color:#111827;text-align:${b.align || "left"};font-family:Arial,sans-serif;">${escapeHtml(personalize(b.text, contact))}</h2>`;
      if (b.type === "text")
        return `<p style="margin:0 0 12px;font-size:15px;line-height:1.6;color:#374151;text-align:${b.align || "left"};font-family:Arial,sans-serif;">${escapeHtml(personalize(b.text, contact))}</p>`;
      if (b.type === "image") {
        if (!b.url)
          return `<div style="margin:0 0 12px;padding:32px;background:#F3F4F6;border:1px dashed #D1D5DB;border-radius:6px;text-align:center;color:#9CA3AF;font-family:Arial,sans-serif;font-size:13px;">Image placeholder — add a URL or upload</div>`;
        let img = `<img src="${escapeHtml(personalize(b.url, contact))}" alt="${escapeHtml(b.alt)}" style="${b.width ? `width:${parseInt(b.width)}px;` : ""}max-width:100%;border-radius:6px;"/>`;
        if (b.link) img = `<a href="${escapeHtml(personalize(b.link, contact))}">${img}</a>`;
        return `<div style="text-align:center;margin:0 0 12px;">${img}</div>`;
      }
      if (b.type === "images") {
        const items = (b.items || []).filter((it) => it.url);
        if (!items.length)
          return `<div style="margin:0 0 12px;padding:28px;background:#F3F4F6;border:1px dashed #D1D5DB;border-radius:6px;text-align:center;color:#9CA3AF;font-family:Arial,sans-serif;font-size:13px;">Image row — add images in the panel</div>`;
        const width = (100 / items.length).toFixed(2);
        const tds = items.map((it) => {
          let img = `<img src="${escapeHtml(personalize(it.url, contact))}" alt="${escapeHtml(it.alt)}" width="100%" style="width:100%;height:auto;border-radius:6px;display:block;"/>`;
          if (it.link) img = `<a href="${escapeHtml(personalize(it.link, contact))}">${img}</a>`;
          return `<td width="${width}%" valign="top" style="padding:4px;">${img}</td>`;
        }).join("");
        return `<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="margin:0 0 12px;"><tr>${tds}</tr></table>`;
      }
      if (b.type === "button")
        return `<div style="text-align:${b.align || "center"};margin:8px 0 16px;"><a href="${escapeHtml(personalize(b.url, contact))}" style="display:inline-block;background:${b.color || "#6366F1"};color:#fff;text-decoration:none;padding:12px 28px;border-radius:6px;font-weight:600;font-family:Arial,sans-serif;font-size:15px;">${escapeHtml(personalize(b.text, contact))}</a></div>`;
      if (b.type === "divider") return `<hr style="border:none;border-top:1px solid #E5E7EB;margin:16px 0;"/>`;
      if (b.type === "spacer") return `<div style="height:${b.height || 24}px;"></div>`;
      if (b.type === "html") return personalize(b.html || "", contact);
      if (b.type === "cards") {
        const cols = Math.max(1, Math.min(3, b.columns || 2));
        const width = (100 / cols).toFixed(2);
        const items = b.items || [];
        let rows = "";
        for (let i = 0; i < items.length; i += cols) {
          let tds = "";
          const chunk = items.slice(i, i + cols);
          chunk.forEach((it) => {
            const title = escapeHtml(personalize(it.title, contact));
            const url = escapeHtml(personalize(it.url || "#", contact));
            const oldHtml = it.old_price ? ` <span style="color:#9CA3AF;font-weight:400;text-decoration:line-through;font-size:12px;">${escapeHtml(it.old_price)}</span>` : "";
            const priceHtml = it.price ? `<div style="margin:2px 0 0;font-family:Arial,sans-serif;font-size:15px;font-weight:700;color:#111827;">${escapeHtml(it.price)}${oldHtml}</div>` : "";
            const btnHtml = it.button ? `<div style="margin-top:10px;"><a href="${url}" style="display:inline-block;background:${b.color || "#6366F1"};color:#fff;text-decoration:none;padding:8px 18px;border-radius:6px;font-family:Arial,sans-serif;font-size:13px;font-weight:600;">${escapeHtml(personalize(it.button, contact))}</a></div>` : "";
            const imgHtml = it.image
              ? `<img src="${escapeHtml(it.image)}" alt="" style="width:100%;height:auto;border-radius:8px;display:block;"/>`
              : `<div style="width:100%;padding:36px 0;background:#F3F4F6;border-radius:8px;color:#9CA3AF;font-family:Arial,sans-serif;font-size:12px;">Image</div>`;
            tds += `<td width="${width}%" valign="top" style="padding:6px;"><div style="border:1px solid #E5E7EB;border-radius:10px;padding:10px;text-align:center;background:#fff;">${imgHtml}<div style="font-family:Arial,sans-serif;font-size:14px;font-weight:600;color:#111827;margin:10px 0 0;">${title}</div>${priceHtml}${btnHtml}</div></td>`;
          });
          for (let p = chunk.length; p < cols; p++) tds += `<td width="${width}%" style="padding:6px;"></td>`;
          rows += `<tr>${tds}</tr>`;
        }
        return `<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="margin:0 0 12px;">${rows}</table>`;
      }
      return "";
    })
    .join("");
}

export function footerHtml(footer) {
  const f = footer || {};
  const esc = escapeHtml;
  let rows = "";
  if (f.company_name) rows += `<div style="font-family:Arial,sans-serif;font-size:14px;font-weight:700;color:#374151;margin-bottom:4px;">${esc(f.company_name)}</div>`;
  if (f.address) rows += `<div style="font-family:Arial,sans-serif;font-size:12px;color:#9CA3AF;margin-bottom:4px;">${esc(f.address)}</div>`;
  const support = [f.support_email, f.support_phone].filter(Boolean).map(esc);
  if (support.length) rows += `<div style="font-family:Arial,sans-serif;font-size:12px;color:#9CA3AF;margin-bottom:6px;">Support: ${support.join(" · ")}</div>`;
  const socials = [["website", "Website"], ["facebook", "Facebook"], ["instagram", "Instagram"], ["youtube", "YouTube"]]
    .filter(([k]) => f[k])
    .map(([, label]) => `<span style="color:#A1090B;font-weight:600;">${label}</span>`);
  if (socials.length) rows += `<div style="font-family:Arial,sans-serif;font-size:12px;margin-bottom:8px;">${socials.join(" · ")}</div>`;
  rows += `<div style="font-family:Arial,sans-serif;font-size:11px;color:#9CA3AF;">You are receiving this because you are a customer. <span style="text-decoration:underline;">Unsubscribe</span></div>`;
  return `<div style="background:#F9FAFB;border-top:1px solid #E5E7EB;padding:20px 32px;text-align:center;border-radius:0 0 8px 8px;">${rows}</div>`;
}

export function wrapPreview(bodyHtml, footer) {
  return `<div style="background:#F3F4F6;padding:24px 12px;"><div style="max-width:600px;margin:0 auto;background:#fff;border-radius:8px;overflow:hidden;"><div style="padding:32px;">${bodyHtml}</div>${footerHtml(footer)}</div></div>`;
}
